export default "__VITE_ASSET__Dz83ioOY__"